import contacts from "../../../data/contacts.json";

type Contact = {
  name: string;
  type: "normal" | "social";
  title: string;
  href: string;
  label: string;
};

export function getContacts(type?: "normal" | "social"): Contact[] {
  return contacts.filter((contact) =>
    type ? contact.type === type : contact.type !== "address"
  ) as Contact[];
}

export function getContact(name: string): Contact | null {
  return (contacts.find((contact) => contact.name === name) as Contact) || null;
}
